import { FiBook, FiEdit3, FiFileText, FiX } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import styles from "./TopicFormModal.module.css";

const TopicFormModal = ({ isOpen, mode, values, onChange, onClose, onSubmit, saving, error, subjectName }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  const isCreateMode = mode === "create";
  const title = isCreateMode ? t("pages.topicForm.createTitle") : t("pages.topicForm.editTitle");

  return (
    <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="topic-modal-title">
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.titleWrap}>
            <span className={styles.headerIcon}>{isCreateMode ? <FiBook size={22} /> : <FiEdit3 size={22} />}</span>
            <div className={styles.titleBlock}>
              <h2 id="topic-modal-title" className={styles.title}>{title}</h2>
              {subjectName && <p className={styles.subtitle}>{t("pages.topicForm.subjectLabel", { name: subjectName })}</p>}
            </div>
          </div>
          <button type="button" className={styles.closeBtn} onClick={onClose} aria-label={t("pages.topicForm.closeAria")}>
            <FiX size={20} />
          </button>
        </div>

        <form onSubmit={onSubmit} className={styles.form}>
          <div className={styles.formBody}>
            <div className={styles.formGroup}>
              <label className={styles.label}>{t("pages.topicForm.topicName")}</label>
              <input
                type="text"
                name="name"
                value={values.name}
                onChange={onChange}
                className={styles.input}
                placeholder={t("pages.topicForm.topicNamePlaceholder")}
                autoComplete="off"
              />
            </div>

            <div className={styles.formGroup}>
              <label className={styles.label}>
                <FiFileText size={14} className={styles.labelIcon} />
                {t("pages.topicForm.description")}
              </label>
              <textarea
                name="description"
                value={values.description}
                onChange={onChange}
                className={styles.textarea}
                placeholder={t("pages.topicForm.descriptionPlaceholder")}
                rows={4}
              />
            </div>

            {error && (
              <div className={styles.error} role="alert">
                {error}
              </div>
            )}
          </div>

          <div className={styles.actions}>
            <button type="button" onClick={onClose} className={styles.secondaryBtn}>
              {t("common.cancel")}
            </button>
            <button type="submit" disabled={saving} className={styles.primaryBtn}>
              {saving ? t("pages.topicForm.saving") : isCreateMode ? t("pages.topicForm.addBtn") : t("pages.topicForm.saveBtn")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TopicFormModal;
